import React from "react";
import styles from "./FullWidthTeaser.module.less";
import Container from "../Container/Container";
import Button from "../Button/Button";

export interface Props {
    heading: string;
    body: string;
    backgroundImage: string;
    linkText: string;
    linkTo: string;
}

export default function FullWidthTeaser(props: Props) {
    return (
        <section className={styles.FullWidthTeaser} style={{ backgroundImage: `url(${props.backgroundImage})` }}>
            <Container>
                <h2>{props.heading}</h2>

                <p>{props.body}</p>

                <Button to={props.linkTo}>{props.linkText}</Button>
            </Container>
        </section>
    );
}
